// IMPORTANT: We are currently working on the new nav v4 (bbc_nav_v4)
// This code is just for the help popup in nav 3. If you are making
// any changes in this file, make sure you add the equivalent to top-nav-help.tsx
// or your changes will not be in the new navigation (nav v4).
import { useState, useContext, useCallback } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { injectIntl, InjectedIntl } from 'react-intl';

import { Help } from '@atlaskit/atlassian-navigation';
import { Popup } from '@atlaskit/popup';
import { token } from '@atlaskit/tokens';

import { useBlogs } from '../blog-fetch';
import HelpMenu from '../help-menu';

import { HorizontalNavContext } from './horizontal-nav-context';
import messages from './horizontal-nav.i18n';

const StyledHelpBadge = styled.span<{
  parentColor: string;
}>(props => ({
  display: 'block',
  width: token('space.100'),
  height: token('space.100'),
  backgroundColor: token('color.icon.discovery'),
  position: 'absolute',
  top: 0,
  left: token('space.300'),
  borderRadius: token('radius.full'),
  border: `3px solid ${props.parentColor}`,
}));

const StyledHelpButtonWrapper = styled.div({
  position: 'relative',
});

export const HorizontalHelpPopup = injectIntl(
  (props: { intl: InjectedIntl }) => {
    const [isOpen, setIsOpen] = useState(false);
    const {
      whatsNewUrl,
      attributionsUrl,
      userUuid,
      onKeyboardShortcutsActivated,
      onFeedbackModalOpen,
      publishUiEvent,
      currentUser,
    } = useContext(HorizontalNavContext);
    const { blogs, newBlogCount, storeLastSeenBlog } = useBlogs(
      whatsNewUrl,
      userUuid || 'anonymous'
    );
    const isAtlassian = currentUser?.is_staff;
    const popupContent = useCallback(
      () => (
        <HelpMenu
          blogs={blogs}
          attributionsUrl={attributionsUrl}
          newBlogCount={newBlogCount}
          storeLastSeenBlog={storeLastSeenBlog}
          onKeyboardShortcutsActivated={onKeyboardShortcutsActivated}
          onFeedbackModalOpen={onFeedbackModalOpen}
          publishUiEvent={publishUiEvent}
          isAtlassian={isAtlassian}
        />
      ),
      [
        blogs,
        attributionsUrl,
        newBlogCount,
        publishUiEvent,
        storeLastSeenBlog,
        onKeyboardShortcutsActivated,
        onFeedbackModalOpen,
        isAtlassian,
      ]
    );
    return (
      <Popup
        placement="bottom-start"
        content={popupContent}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        trigger={triggerProps => (
          <StyledHelpButtonWrapper>
            <Help
              onClick={() => setIsOpen(!isOpen)}
              tooltip={props.intl.formatMessage(messages.helpTooltip)}
              testId="horizontal-nav-help-button"
              {...triggerProps}
            />
            {newBlogCount ? (
              <StyledHelpBadge
                parentColor={token('color.border.inverse')}
                data-testid="horizontal-nav-help-badge"
              />
            ) : null}
          </StyledHelpButtonWrapper>
        )}
      />
    );
  }
);
